enum UploadFileTypeEnum {
  DROPBOX = 'dropboxFile',
  COMPUTER_FILE = 'computer',
}

export default UploadFileTypeEnum;
